import { Dispatch, memo, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { DescriptionOfWarehouseItem } from "../../../constants/common";
import Accordion from "../../../components/accordian";
import { Plus } from "lucide-react";
import { Button } from "../../../components/button";
import DescriptionOfWarehouseItemsTable from "../../../components/table/DescriptionOfWarehouseItemsTable";
import AddDescriptionOfWarehouseItemCard from "../../../components/card/AddDescriptionOfWarehouseItemCard";
import { APP_ROUTES } from "../../../routes";
import { useLocation } from "react-router-dom";

interface VisitorsGroupProps {
  addedDescriptionOfWarehouseItems: DescriptionOfWarehouseItem[];
  setAddedDescriptionOfWarehouseItems: Dispatch<
    SetStateAction<DescriptionOfWarehouseItem[]>
  >;
  isFieldsDisabled: boolean;
}

const DescriptionOfWarehouseItems = ({
  addedDescriptionOfWarehouseItems,
  setAddedDescriptionOfWarehouseItems,
  isFieldsDisabled,
}: VisitorsGroupProps) => {
  const location = useLocation();

  const [isAddVisitorFormVisible, setIsAddItemFormVisible] =
    useState<boolean>(true);

  const [selectedKey, setSelectedKey] = useState<string>("1");

  const { t } = useTranslation();

  const [editingItem, setEditingItem] =
    useState<DescriptionOfWarehouseItem | null>(null);

  const handleFormReset = () => {
    setEditingItem(null);
  };

  return (
    <div className="bg-white p-2 md:p-4 rounded-xl flex flex-col gap-3 lg:gap-6 shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
      <Accordion
        id="1"
        selectedKey={selectedKey}
        onSelectionChange={setSelectedKey}
        title={
          <h1 className="text-xl md:text-2xl flex flex-1 -mt-2 items-center">
            {t("3")}. {t("detailedDescriptionOfItems")}
          </h1>
        }
      >
        <div className="flex flex-col gap-2">
          <div className="grid md:flex md:justify-end gap-1">
            {!isFieldsDisabled && (
              <Button
                type="button"
                onClick={() => {
                  setIsAddItemFormVisible(false);
                  setEditingItem(null);

                  setTimeout(() => {
                    setIsAddItemFormVisible(true);
                  }, 0);
                }}
                Icon={<Plus size={20} />}
              >
                {t("addDescription")}
              </Button>
            )}
          </div>

          <DescriptionOfWarehouseItemsTable
            addedDescriptionOfWarehouseItems={addedDescriptionOfWarehouseItems}
            setAddedDescriptionOfWarehouseItems={
              setAddedDescriptionOfWarehouseItems
            }
            //   isVipDelegations={isVipDelegations}
            setEditingItem={setEditingItem}
            setIsAddItemFormVisible={setIsAddItemFormVisible}
            onFormReset={handleFormReset}
            //   setSelectedWorkerIds={setSelectedWorkerIds}
            //   isSendForApproval={isSendForApproval}
            isFieldsDisabled={isFieldsDisabled}
          />

          {isAddVisitorFormVisible && (
            <AddDescriptionOfWarehouseItemCard
              setIsAddItemFormVisible={setIsAddItemFormVisible}
              setAddedDescriptionOfWarehouseItems={
                setAddedDescriptionOfWarehouseItems
              }
              editingItem={editingItem}
              setEditingItem={setEditingItem}
              isFieldsDisabled={isFieldsDisabled}
            />
          )}
        </div>
      </Accordion>
    </div>
  );
};

export default memo(DescriptionOfWarehouseItems);
